import { VesselStay } from "../hooks/useFetchVesselStays"

export function getProlongedStay(stays: VesselStay[]): {
  result: string
  consecutiveDates: { from: string; to: string }[]
  prolongedPort: { port: string; duration: number; from: string } | null
} {
  // Filter the stays based on the given criteria
  const filteredData = stays.filter(
    (stay) =>
      !stay.yard_activity &&
      stay.yard_activity !== "DD-R" &&
      stay.yard_activity !== "R"
  )
  let result = "low" // Default result
  let currentConsecutiveDays = 0
  let consecutiveDates: { from: string; to: string }[] = []
  let prolongedPort: { port: string; duration: number; from: string } | null =
    null

  if (filteredData.length > 5) {
    // Sliding window logic for every 5 data
    for (let i = 0; i <= filteredData.length - 5; i++) {
      const chunk = filteredData.slice(i, i + 5)
      // Check for high, medium, or low conditions
      const highStays = chunk.filter((stay) => stay.duration >= 20)
      const over10Days = chunk.filter((stay) => stay.duration >= 10)

      highStays.forEach((stay) => {
        if (!prolongedPort || stay.duration > prolongedPort.duration) {
          prolongedPort = {
            port: stay.port,
            duration: stay.duration,
            from: stay.date_from,
          }
        }
      })

      if (highStays.length > 0) {
        result = "high"
      } else if (over10Days.length >= 3) {
        result = "high" // Prioritize "high" over "medium"
      } else if (over10Days.length === 2 && result !== "high") {
        result = "medium" // Only update to "medium" if not already "high"
      }

      if (over10Days.length >= 2) {
        over10Days.forEach((stay) => {
          consecutiveDates.push({ from: stay.date_from, to: stay.date_to })
        })
      }
    }
    if (consecutiveDates.length > 0) {
      consecutiveDates = consecutiveDates.filter(
        (value, index, self) =>
          index ===
          self.findIndex((t) => t.from === value.from && t.to === value.to)
      )
    }
  } else {
    for (let i = 0; i <= filteredData.length; i++) {
      const chunk = filteredData

      // Check for high, medium, or low conditions
      const highStays = chunk.filter((stay) => stay.duration >= 20)
      const over10Days = chunk.filter((stay) => stay.duration >= 10)

      highStays.forEach((stay) => {
        if (!prolongedPort || stay.duration > prolongedPort.duration) {
          prolongedPort = {
            port: stay.port,
            duration: stay.duration,
            from: stay.date_from,
          }
        }
      })

      if (highStays.length > 0) {
        result = "high"
      } else if (over10Days.length >= 3) {
        result = "high" // Prioritize "high" over "medium"
      } else if (over10Days.length === 2 && result !== "high") {
        result = "medium" // Only update to "medium" if not already "high"
      }

      if (over10Days.length >= 2) {
        over10Days.forEach((stay) => {
          consecutiveDates.push({ from: stay.date_from, to: stay.date_to })
        })
      }
    }
    // Remove duplicates from consecutiveDates
    if (consecutiveDates.length > 0) {
      consecutiveDates = consecutiveDates.filter(
        (value, index, self) =>
          index ===
          self.findIndex((t) => t.from === value.from && t.to === value.to)
      )
    }
  }
  return { result, consecutiveDates, prolongedPort }
}

export const triangleStyles = {
  high: {
    fill: "red", // Red fill for "high"
    stroke: "white", // White stroke for "high"
  },
  medium: {
    fill: "yellow", // Yellow fill for "medium"
    stroke: "black", // Black stroke for "medium"
  },
}

export function formatDateToShortMonthYear(dateString: string): string {
  // Create a Date object from the input date string
  const date = new Date(dateString)

  // Define an array of month abbreviations
  const months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ]

  // Extract the month and year
  const month = months[date.getMonth()] // getMonth() returns a zero-based index
  const year = date.getFullYear().toString().slice(-2) // Get the last two digits of the year

  // Return the formatted date string
  return `${month}'${year}`
}
